/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourModelDeleteFeatureInput = {|
  featureId: string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderCalcTabDeleteFeatureMutationVariables = {|
  input: PGATourModelDeleteFeatureInput
|};
export type PGAModelBuilderCalcTabDeleteFeatureMutationResponse = {|
  +pgaTourModelDeleteFeature: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderCalcTabDeleteFeatureMutation = {|
  variables: PGAModelBuilderCalcTabDeleteFeatureMutationVariables,
  response: PGAModelBuilderCalcTabDeleteFeatureMutationResponse,
|};
*/


/*
mutation PGAModelBuilderCalcTabDeleteFeatureMutation(
  $input: PGATourModelDeleteFeatureInput!
) {
  pgaTourModelDeleteFeature(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourModelDeleteFeaturePayload",
    "kind": "LinkedField",
    "name": "pgaTourModelDeleteFeature",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcTabDeleteFeatureMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderCalcTabDeleteFeatureMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1ead2bd42f33277728126eb5363ae1c1",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcTabDeleteFeatureMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderCalcTabDeleteFeatureMutation(\n  $input: PGATourModelDeleteFeatureInput!\n) {\n  pgaTourModelDeleteFeature(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8eeea7f44a381a7f7e4f5b13066615dd';

module.exports = node;
